import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRtlzweiComponent } from './simple-icons-rtlzwei.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRtlzweiComponent ],
    exports:      [ SimpleIconsRtlzweiComponent ],
    bootstrap:    []
})
export class SimpleIconsRtlzweiModule {}
